"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigEvent = exports.isConfigUpdateMessage = void 0;
function isConfigUpdateMessage(message) {
    return message.event !== undefined;
}
exports.isConfigUpdateMessage = isConfigUpdateMessage;
var ConfigEvent;
(function (ConfigEvent) {
    ConfigEvent["PopupLoaded"] = "PopupLoaded";
    ConfigEvent["PopupUnload"] = "PopupUnload";
    ConfigEvent["WalletLinkSessionRequest"] = "WalletLinkSessionRequest";
    ConfigEvent["SelectSignerType"] = "selectSignerType";
    ConfigEvent["WalletLinkUpdate"] = "WalletLinkUpdate";
})(ConfigEvent || (exports.ConfigEvent = ConfigEvent = {}));
